import { number_growth_float } from '../animation/number.js';
import { mean, median, mode} from '../data_processing/statistics.js'

/**
 * Generate a statistics card with a numerical value and append it to a specified HTML element.
 *
 * @param {Array} arr_data The array of data.
 * @param {string} id The ID of the HTML element where the card will be appended.
 * @param {string} target_col The column in the data array to perform the operation on.
 * @param {Object} mapping_table An object that maps column names to their display titles.
 * @param {string} operation The statistical operation to perform (e.g., "mean", "mode", "median").
 */
export function generate_stats_num_div(arr_data, id, target_col, mapping_table, operation) {
    const operations = {
        mean,
        mode,
        median
    };

    const container = document.getElementById(id);
    // Check if the element already exists
    let colDiv = container.querySelector(`.${target_col}`);
    let avg = operations[operation](arr_data, target_col);
    const title = mapping_table[target_col];

    if (!colDiv) {
        // Create new elements if they don't exist
        colDiv = document.createElement('div');
        colDiv.className = `col mb-2 ${target_col}`;

        const cardDiv = document.createElement('div');
        cardDiv.className = 'card rounded-4 mt-3 border-0 my-2 h-100';

        const cardBodyDiv = document.createElement('div');
        cardBodyDiv.className = 'card-body px-0';

        const h6 = document.createElement('h6');
        h6.textContent = title;

        const hr = document.createElement('hr');

        const p = document.createElement('p');
        p.className = 'card-big-num fs-4';
        p.textContent = `${avg}`;

        cardBodyDiv.appendChild(h6);
        cardBodyDiv.appendChild(hr);
        cardBodyDiv.appendChild(p);
        cardDiv.appendChild(cardBodyDiv);
        colDiv.appendChild(cardDiv);
        container.appendChild(colDiv);

        // Animation
        number_growth_float(p, 0, avg, 500);
    } else {
        // Update the existing elements
        const p = colDiv.querySelector('.card-big-num');
        p.textContent = `${avg}`;

        // Animation
        number_growth_float(p, 0, avg, 500);
    }
}